import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const LeftCard = ({
  selectedExpertises,
  selectedServices,
  selectedLanguages,
  onExpertiseChange,
  onServiceChange,
  onLanguageChange,
  onClearSelections,
  indicators,
  onSortChange,
  onSearchChange,
  onFilterChange,
  filterStatus,
  sortStatus,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [activeSortOption, setActiveSortOption] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [activeFilters, setActiveFilters] = useState([]);

  const handleSidebarSortChange = (sortKey) => {
  setActiveSortOption(sortKey);
    onSortChange(sortKey);
  };
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onSearchChange(value);
  };
  const handleLinkClick = (filterKey) => {
    let updatedFilters;

    if (activeFilters.includes(filterKey)) {
      updatedFilters = activeFilters.filter((f) => f !== filterKey);
    } else {
      updatedFilters = [...activeFilters, filterKey];
    }
    setActiveFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/experts/${cookieLang}.json`)
        .then((data) => setLanguageData(data))
        .catch((error) => console.error("Error loading language file:", error));
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  const hasFilters =
    selectedExpertises?.length > 0 ||
    selectedServices?.length > 0 ||
    selectedLanguages?.length > 0 ||
    filterStatus?.length > 0 ||
    sortStatus !== null ||
    Boolean(searchValue?.trim());

  const APP_SERVICES = process.env.REACT_APP_APP_SERVICES;
  const SERVICES = APP_SERVICES.split(",").map((s) => s.trim().toLowerCase());
  return (
    <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-12">
      <div className="card custom-card products-navigation-card">
        <div className="card-body p-0">
          <nav
            className="navbar-expand-xxl"
            ref={(el) => {
              if (el) el.style.setProperty("flex-wrap", "wrap", "important");
            }}
          >
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom ">
              <h6 className="mb-0 text-muted">{languageData.filters.title}</h6>
              <button
                data-interaction="filter_by_button"
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedleft"
                aria-controls="navbarSupportedleft"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon1"></span>
              </button>
            </div>
            <div className="p-3 d-flex border-bottom" role="search">
              <input
                className="form-control form-control-sm me-1"
                type="search"
                name="search"
                placeholder={languageData.filters.search}
                aria-label="Search"
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>
            <div
              className="collapse navbar-collapse navbar-justified "
              id="navbarSupportedleft"
            >
              <div className="flex-column">
                {/* Expertises Section */}
                <div className="p-4 border-bottom">
                  <p className="fw-semibold mb-0 text-muted flex">
                    {languageData.sidebar.expertises.title}
                  </p>
                  <div className="py-3 pb-0 text-start">
                    {Object.entries(languageData.sidebar.expertises).map(
                      ([key, value]) =>
                        key !== "title" && (
                          <div className="form-check mb-2" key={key}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="expertises_filter"
                              id={key}
                              checked={selectedExpertises.includes(key)}
                              onChange={onExpertiseChange}
                            />
                            <label className="form-check-label" htmlFor={key}>
                              {value}
                            </label>
                            <span className="badge bg-light text-muted float-end">
                              {indicators.expertises[key] || 0}
                            </span>
                          </div>
                        ),
                    )}
                  </div>
                </div>

                {/* Services Section */}
                <div className="p-4 border-bottom">
                  <p className="fw-semibold mb-0 text-muted flex">
                    {languageData.sidebar.service.title}
                  </p>
                  <div className="py-3 pb-0 text-start">
                    {Object.entries(languageData.sidebar.service).map(
                      ([key, value]) => {
                        if (
                          key === "title" ||
                          !SERVICES.includes(key.trim().toLowerCase())
                        ) {
                          return null;
                        }

                        return (
                          <div className="form-check mb-2" key={key}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="services_filter"
                              id={key}
                              checked={selectedServices.includes(key)}
                              onChange={onServiceChange}
                            />

                            <label className="form-check-label" htmlFor={key}>
                              {value}
                            </label>

                            <span className="badge bg-light text-muted float-end">
                              {indicators.services[key] || 0}
                            </span>
                          </div>
                        );
                      },
                    )}
                  </div>
                </div>

                {/* Languages Section */}
                <div className="p-4 border-bottom">
                  <p className="fw-semibold mb-0 text-muted flex">
                    {languageData.sidebar.languages.title}
                  </p>
                  <div className="py-3 pb-0 text-start">
                    {Object.entries(languageData.sidebar.languages).map(
                      ([key, value]) =>
                        key !== "title" && (
                          <div className="form-check mb-2" key={key}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="languages_filter"
                              id={key}
                              checked={selectedLanguages.includes(key)}
                              onChange={onLanguageChange}
                            />
                            <label className="form-check-label" htmlFor={key}>
                              {value}
                            </label>
                            <span className="badge bg-light text-muted float-end ">
                              {indicators.languages[key] || 0}
                            </span>
                          </div>
                        ),
                    )}
                  </div>
                </div>

                {/* sort by Section */}
                <div className="p-4 border-bottom">
                  <p className="fw-semibold mb-0 text-muted flex">
                    {languageData.sidebar.sort_by.title}
                  </p>
                  <div className="py-3 pb-0 text-start">
                    {Object.entries(languageData.sidebar.sort_by).map(
                      ([key, value]) =>
                        key !== "title" && (
                          <div className="form-check mb-2" key={key}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="sort_by_filter"
                              id={key}
                              checked={sortStatus === key}
                              onChange={() => handleSidebarSortChange(key)}
                            />
                            <label className="form-check-label" htmlFor={key}>
                              {value}
                            </label>
                          </div>
                        ),
                    )}
                  </div>
                </div>

                {/* disponible & favoris Section */}
                <div className="p-4 border-bottom">
                  <p className="fw-semibold mb-0 text-muted flex">
                    {languageData.sidebar.filter.title}
                  </p>
                  <div className="py-3 pb-0 text-start">
                    {Object.entries(languageData.sidebar.filter).map(
                      ([key, value]) =>
                        key !== "title" && (
                          <div className="form-check mb-2" key={key}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="filter_status"
                              id={key}
                              checked={filterStatus?.includes(key) || false}
                              onChange={onFilterChange}
                            />

                            <label className="form-check-label" htmlFor={key}>
                              {value}
                            </label>
                          </div>
                        ),
                    )}
                  </div>
                </div>

                {/* Reset Button */}
                {hasFilters && (
                  <div className="p-4">
                    <button
                      data-interaction="reset_filter_experts_button"
                      className="btn btn-sm w-100 reset_btn"
                      onClick={onClearSelections}
                    >
                      {languageData.filters.reset || "Reset"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default LeftCard;
